import React from 'react';
import MockTestTransformation from '../../MockTestTransformation/MockTestTransformation';

const PortalMockTestTransformation = () => {
  return <MockTestTransformation backPath="/portal/test-management" />;
};

export default PortalMockTestTransformation;
